export const CEvoDocNumber = {
  field: `
      fragment evoDocNumber on evoDocNumber_MatrixField {
        ... on evoDocNumber_localeNumber_Entry {
          id
          locale
          docNumber
        }
      }
    `,
}
